export const TANZANIA_REGIONS: Record<string, string[]> = {
  "Arusha": ["Arusha City", "Arusha District", "Karatu", "Longido", "Meru", "Monduli", "Ngorongoro"],
  "Dar es Salaam": ["Ilala", "Kinondoni", "Temeke", "Ubungo", "Kigamboni"],
  "Dodoma": ["Bahi", "Chamwino", "Chemba", "Dodoma City", "Kondoa", "Kongwa", "Mpwapwa"],
  "Geita": ["Bukombe", "Chato", "Geita", "Mbogwe", "Nyanghwale"],
  "Iringa": ["Iringa District", "Iringa Municipal", "Kilolo", "Mafinga Town", "Mufindi"],
  "Kagera": ["Biharamulo", "Bukoba District", "Bukoba Municipal", "Karagwe", "Kyerwa", "Missenyi", "Muleba", "Ngara"],
  "Katavi": ["Mlele", "Mpanda District", "Mpanda Town"],
  "Kigoma": ["Buhigwe", "Kakonko", "Kasulu District", "Kasulu Town", "Kibondo", "Kigoma District", "Kigoma-Ujiji", "Uvinza"],
  "Kilimanjaro": ["Hai", "Moshi District", "Moshi Municipal", "Mwanga", "Rombo", "Same", "Siha"],
  "Lindi": ["Kilwa", "Lindi District", "Lindi Municipal", "Liwale", "Nachingwea", "Ruangwa"],
  "Manyara": ["Babati District", "Babati Town", "Hanang", "Kiteto", "Mbulu District", "Mbulu Town", "Simanjiro"],
  "Mara": ["Bunda", "Butiama", "Musoma District", "Musoma Municipal", "Rorya", "Serengeti", "Tarime"],
  "Mbeya": ["Busokelo", "Chunya", "Mbarali", "Mbeya City", "Mbeya District", "Rungwe"],
  "Morogoro": ["Gairo", "Kilombero", "Kilosa", "Morogoro District", "Morogoro Municipal", "Mvomero", "Ulanga", "Malinyi"],
  "Mtwara": ["Masasi District", "Masasi Town", "Mtwara District", "Mtwara Municipal", "Nanyumbu", "Newala", "Tandahimba"],
  "Mwanza": ["Ilemela", "Kwimba", "Magu", "Misungwi", "Nyamagana", "Sengerema", "Ukerewe"],
  "Njombe": ["Ludewa", "Makambako Town", "Makete", "Njombe District", "Njombe Town", "Wanging'ombe"],
  "Pemba North": ["Micheweni", "Wete"],
  "Pemba South": ["Chake Chake", "Mkoani"],
  "Pwani": ["Bagamoyo", "Kibaha District", "Kibaha Town", "Kisarawe", "Mafia", "Mkuranga", "Rufiji"],
  "Rukwa": ["Kalambo", "Nkasi", "Sumbawanga District", "Sumbawanga Municipal"],
  "Ruvuma": ["Mbinga District", "Mbinga Town", "Namtumbo", "Nyasa", "Songea District", "Songea Municipal", "Tunduru"],
  "Shinyanga": ["Kahama Town", "Kishapu", "Shinyanga District", "Shinyanga Municipal", "Ushetu"],
  "Simiyu": ["Bariadi", "Busega", "Itilima", "Maswa", "Meatu"],
  "Singida": ["Ikungi", "Iramba", "Manyoni", "Mkalama", "Singida District", "Singida Municipal"],
  "Songwe": ["Ileje", "Mbozi", "Momba", "Songwe"],
  "Tabora": ["Igunga", "Kaliua", "Nzega District", "Nzega Town", "Sikonge", "Tabora Municipal", "Urambo", "Uyui"],
  "Tanga": ["Handeni District", "Handeni Town", "Kilindi", "Korogwe District", "Korogwe Town", "Lushoto", "Mkinga", "Muheza", "Pangani", "Tanga City"],
  "Unguja North": ["Kaskazini A", "Kaskazini B"],
  "Unguja South": ["Kati", "Kusini"],
  "Unguja Urban/West": ["Magharibi A", "Magharibi B", "Mjini"],
};

export const getRegions = (): string[] => Object.keys(TANZANIA_REGIONS).sort();

export const getDistricts = (region: string): string[] => {
  return TANZANIA_REGIONS[region] || [];
};
